import React from 'react';
import { strings } from '../../localization';
import { Select } from 'antd';

const MeterSelectBox = ({meterChange, selectedMeter, metersData, isAdmin = false}) => {

    const createItem = meter => (
        <Select.Option value={meter.get('id')} key={`key${meter.get('id')}`}>
            {isAdmin &&
            meter.get('home') &&
            meter.getIn(['home', 'ownerUser'])
                ? `[${meter.getIn(['home', 'ownerUser', 'surename']) ||
                ''} ${meter.getIn(['home', 'ownerUser', 'name']) ||
                ''}] `
                : ''}
            {meter.get('home') ? `[${meter.getIn(['home', 'name'])}]` : ''}{' '}
            {meter.get('name')}
        </Select.Option>
    );

    return (
        <span>
            <span style={{ marginRight: 10 }}>{strings.dashboard.selectedMeter}</span>
            <Select
                onChange={meterChange}
                value={selectedMeter}
                dropdownMatchSelectWidth={false}
                style={{ minWidth: '300px' }}
            >
                {metersData &&
                metersData.map(meter => (
                    createItem(meter)
                ))}
            </Select>
        </span>
    );
};

export default MeterSelectBox;